import type { AddressSubmissionData } from '@duke-hq/google-address/types';

export type ContactDetails = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  preferredContactMethod: '' | 'EMAIL' | 'PHONE';
};

export type BusinessDetails = {
  name: string;
  abn: string;
  businessType: string;
  contact: ContactDetails;
};

export type UploadedDoc = { filename: string; drn: string };

export type PlacementsDetails = {
  readyForPlacements: boolean;
  agreement: UploadedDoc | null;
  agreementExpiresAt: string;
  insurance: UploadedDoc | null;
  insuranceExpiresAt: string;
};

export type EmployerAddress = AddressSubmissionData;

export const emptyBusinessDetails: BusinessDetails = {
  name: '',
  abn: '',
  businessType: '',
  contact: { firstName: '', lastName: '', email: '', phone: '', preferredContactMethod: '' },
};

export const emptyPlacements: PlacementsDetails = {
  readyForPlacements: false,
  agreement: null,
  agreementExpiresAt: '',
  insurance: null,
  insuranceExpiresAt: '',
};

// A contact row is only created when the user actually named someone.
export function hasNamedContact(contact: ContactDetails): boolean {
  return contact.firstName.trim() !== '' && contact.lastName.trim() !== '';
}
